
    import common from "@/util/common.ts";
    import {useStore} from "@/store";
    import checkItem from './checkItem/checkItem.vue';
    import {defineComponent, computed, ComputedRef, watch, reactive, toRefs} from "vue";

    interface State {
        dataList: object[];
        flawList: object[];
        tocOnlyShowFlaw: boolean;
    }
    export default defineComponent({
        name: 'checkCont',
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                dataList: [],
                flawList: [],
                tocOnlyShowFlaw: false
            });
            const {renderData} = toRefs(props);
            function getData(list, code, key='value', type='') {
                return common.getDataByCode(list,  code, key, type)
            }
            // for (let i = 0; i< renderData.value.length; i += 1) {
            //     let item = renderData.value[i];
            //     let configItems = item.configItems;
            //     let defectCount = Number(getData(configItems, 'defectCount'));
            //     if (defectCount > 0) {
            //         state.flawList.push(item);
            //     }
            // }
            let store = useStore()
            let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            state.dataList = renderData.value;
            watch(tocOnlyShowFlawS, (data: any) => {
                state.tocOnlyShowFlaw = data;
            }, {immediate: true})
            
            return {
                state,
                getData
            }
        },
        components: {
            checkItem
        }
    })
